export const transformValueToBoolean = (value?: string | boolean) => {
  if (typeof value === 'boolean') {
    return value;
  }
  if (!value) {
    return null;
  }
  if (value === 'Y') {
    return true;
  }
  return false;
};

export const transformBooleanToValue = (value?: string | boolean) => {
  if (typeof value === 'boolean') {
    return value ? 'Y' : 'N';
  }
  return null;
};
